var productMetaJson = JSON.parse(document.getElementById('product-meta-json').textContent);
// $(document).on('click', '#dropdown_info', function() {
//   window.location.hash = '#popup';
//   $(".Weitere-model-main").addClass('model-open');
//   $("body").addClass('popup_active');
// }); 
// $(document).on('click', ".Weitere_close_btn, .Weitere_bg_overlay", function(){
//     if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//   $(".Weitere-model-main").removeClass('model-open');
//   $("body").removeClass('popup_active');
// });

// $(document).on('click', '#Zeichnungsstil_dropdown_info', function() {
//   window.location.hash = '#popup';
//   $(".Zeichnungsstil-model-main").addClass('model-open');
//   $("body").addClass('popup_active');
// }); 
// $(document).on('click', ".Zeichnungsstil_close_btn, .Zeichnungsstil_bg_overlay", function(){
//   if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//   $(".Zeichnungsstil-model-main").removeClass('model-open');
//   $("body").removeClass('popup_active');
// });

// $(document).on('click', '#halskette_short_textnain', function() {
//   window.location.hash = '#popup';
//   $(".Handzeichnung-model-main").addClass('model-open');
//   $("body").addClass('popup_active');
// }); 
// $(document).on('click', ".Handzeichnung_close_btn, .Handzeichnung_bg_overlay", function(){
//     if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//   $(".Handzeichnung-model-main").removeClass('model-open');
//   $("body").removeClass('popup_active');
// });

 // front side btn open popup 
// $(document).on('click', '#name_popupbox', function() {
//   var id = $('[data-product-select]').val();
//     var selectedlength = $('.select-trigger .selected-option .list_item').length;
//     var selectedValueNbr = $('.select-trigger .selected-option .list_item').find('.list_item_value').attr('data-number');
//   if(!selectedValueNbr){
//     var selectedValueNbr = 1;
//   }
//     Object.keys(productMetaJson).forEach(function(key) {
//     if(productMetaJson[key].variant_id == id){
//     var productProperties = productMetaJson[key].img[selectedValueNbr-1];
//     $('.Namen-model-main .wrap_image_container img').attr("src",productProperties);
//       $('.Namen-model-main .wrap_image_container').attr('data-person', selectedValueNbr);
//     }
//     });

//     setTimeout(function() {
//       window.location.hash = '#popup';
//      $(".Namen-model-main").addClass('model-open');
//       $("body").addClass('popup_active');
//     }, 500);
// }); 

// front side cancel/skip btn open popup

// $(document).on('click', '.halskette_frontname_texts .fflagship-collapsable-header-button2', function(){
//  var id = $('[data-product-select]').val();
//   var selectedlength = $('.select-trigger .selected-option .list_item').length;
//   var selectedValueNbr = $('.select-trigger .selected-option .list_item').find('.list_item_value').attr('data-number');
//   if(!selectedValueNbr){
//     var selectedValueNbr = 1;
//   }
//     Object.keys(productMetaJson).forEach(function(key) {
//     if(productMetaJson[key].variant_id === id){
//     console.log(selectedValueNbr);
//     var productProperties = productMetaJson[key].img[selectedValueNbr-1];
//     console.log(productProperties);
//     $('.Namen-model-main .wrap_image_container img').attr("src",productProperties);
//     }
//     });
//     setTimeout(function() {
//       window.location.hash = '#popup';
//      $(".Namen-model-main").addClass('model-open');
//      $("body").addClass('popup_active'); 
//     }, 500);
// });


// $(document).on('click', ".Namen_close_btn, .Namen_bg_overlay", function(){
// if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//   $(".Namen-model-main").removeClass('model-open');
//   $("body").removeClass('popup_active');
// });


// // back side btn open popup 
// $(document).on('click', '#ruckseiteng_popupbox', function() {
//   var id = $('[data-product-select]').val();
//   var selectedlength = $('.select-trigger .selected-option .list_item').length;
//     // $('.Ruckseitengravur-model-main .wrap_image_container img').hide();
//     // $('.Ruckseitengravur-model-main .wrap_image_container img[data-id="'+id+'"]').show();
//     setTimeout(function() {
//       window.location.hash = '#popup';
//     $(".Ruckseitengravur-model-main").addClass('model-open');
//       $("body").addClass('popup_active'); 
//     }, 500);
// });


// // back side cancel/skip btn open popup

// $(document).on('click', '.halskette_backname_texts .fflagship-collapsable-header-button2', function(){
//   var id = $('[data-product-select]').val();
//   var selectedlength = $('.select-trigger .selected-option .list_item').length;
//     // $('.Ruckseitengravur-model-main .wrap_image_container img').hide();
//     // $('.Ruckseitengravur-model-main .wrap_image_container img[data-id="'+id+'"]').show();
//     setTimeout(function() {
//        window.location.hash = '#popup';
//     $(".Ruckseitengravur-model-main").addClass('model-open');
//       $("body").addClass('popup_active'); 
//     }, 500);
// });

// $(document).on('click', ".Ruckseitengravur_close_btn, .Ruckseitengravur_bg_overlay", function(){
//     if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//   $(".Ruckseitengravur-model-main").removeClass('model-open');
//   $("body").removeClass('popup_active'); 
// });
$(document).on('click', '#upload_info', function() {
  window.location.hash = '#popup';
  $(".aufFoto-model-main").addClass('model-open');
  $("body").addClass('popup_active');
}); 
$(document).on('click', ".aufFoto_close_btn, .aufFoto_bg_overlay", function(){
  if (window.location.hash) {
    history.replaceState(null, document.title, window.location.pathname + window.location.search);
  }
  $(".aufFoto-model-main").removeClass('model-open');
  $("body").removeClass('popup_active');
});

// $(document).on('click', ".select-trigger.active", function(){
//     $(this).next().slideToggle("fast");
//     $(this).toggleClass('selector_open');
//   $(this).parents('.custom-select').find('.options').toggleClass('selected_open');
//   });

// $(document).on('click', "#halskette_select.options li", function(){
//     var selectedOption = $(this).html();
//     var selectedValue = $(this).attr("value");
//   $('.Namen-model-main .frontname').removeClass('name_active');
// var selectedDataVal = $(this).parents('.halskette_selecteditems').find('.select-trigger .selected-option .list_item .list_item_value').attr('data-value');
// $('.halskette_frontname_texts .halskette_name_texts').html('');
//   $('.halskette_frontname_texts .frontnamecancel_btn').show();
//   $('.halskette_frontname_texts .halskette_name_btn').show();
//   $('.Namen-model-main #popup_name_image').html('');
//   $('.Namen-model-main .popup_name_inputs').val('');
//   $('.Namen-model-main #frontname_1').addClass('name_active');
//   $('.halskette_frontname_texts .halskette_header').show();
//   $('.halskette_frontname_texts .halskette_input_first').show();
//   $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('');
//   $(this).parents('.custom-select').find(".selected-option").html(selectedOption);
//   $('.halskette_personen').val($(this).find('.list_item_value').attr('data-valuePrice'));
//   $("#halskette_select.options").slideUp("fast");
//   $("#halskette_select.options").removeClass("selected_open");
//   $(this).parents('.custom-select').find('.select-trigger').removeClass('selector_open');
//   // Perform any additional actions with the selected value here
//   checkError();
//   getPrice();
//   });


// $(document).on('click', '.Ruckseitengravur-model-main .popup_fonts .frontname', function(){
// $('.Ruckseitengravur-model-main .popup_fonts .frontname').removeClass('name_active');
// $(this).addClass('name_active');


// var hintergrundfarbe = $(this).text();

// $('.Ruckseitengravur-model-main .wrap_image_container img').hide();
// $('.Ruckseitengravur-model-main .wrap_image_container img[data="'+hintergrundfarbe+'"]').show();

// });



// name backside popup save btn
// $(document).on('click', '.Ruckseitengravur-model-main .image_save_btn', function(){
// var hintergrundfarbe = $('.frontname.name_active').text();
// $('.hintergrundfarbe').val(hintergrundfarbe);
// $('.halskette_backname_texts .halskette_rucks_texts').html('');
//   $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('');

// // var fontName = $('.frontname.name_active').text();
// //  var nameInputVal = $(this).parents('.Ruckseitengravur-model-main ').find('.popup_name_inputs').val();
// // var index = $(this).parents('.Ruckseitengravur-model-main ').find('.frontname.name_active').attr('data-numberdata');
//   // var indexPlus = index * 1;

//   if(hintergrundfarbe != ''){
//    // console.log(indexPlus);
//     console.log(hintergrundfarbe);
//      $('.halskette_backname_texts .halskette_rucks_texts').show();
//     $('.halskette_backname_texts .halskette_input_first').show();
//     $('.halskette_backname_texts .halskette_header').hide();
//      $('.halskette_backname_texts .halskette_rucks_texts').append('<div class="halskette_after_savecontainer"><div class="halskette_wrapper_info"><div class="halskette_header halskette_headernew" style="display:block;"><div class="halskette_heading">Hintergrundfarbe</div></div><div class="engraving-messagesection row" data-autom="engraving-message-1"><div class="engraving-messagesection-item"><span style="display:none;">Name: </span><span class="engraving-mixed engraving-messagevalue">'+hintergrundfarbe+'</span></div></div></div><div class="engraving-addbutton"><button class="as-buttonlink engraving-buttonlink engraving-editbutton" type="button" data-trigger-id=".frontname_1"><span>bearbeiten</span></button><span class="engraving-lineseparator"></span><button class="as-buttonlink engraving-buttonlink engraving-remove" type="button" data-input-id=".frontnameinput_1" data-img-id=".frontnameimg_1" data-trigger-id=".frontname_1"><span>löschen</span></button></div></div>');
//     $('.halskette_backname_texts .halskette_name_btn').hide();
//   }else{
// $('.halskette_backname_texts .halskette_rucks_texts').html('');
//      $('.halskette_backname_texts .halskette_header').hide();
//      $('.halskette_backname_texts .halskette_name_btn').hide();
//     $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="flagship-collapsable-header">Rückseite überspringen</span><button class="flagship-collapsable-header-button" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>');
//   }
//       if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
// $(".Ruckseitengravur-model-main").removeClass('model-open');
//   $("body").removeClass('popup_active');
//     $('.halskette_backname_texts .backnamecancel_btn').hide();
// });

// // name front side cancel btn
// $(document).on('click', '.Namen-model-main .image_cancel_btn', function(){
//   $('.Namen-model-main .popup_name_inputs').each(function(){
//    // console.log($('.halskette_frontname_texts .halskette_name_texts').children().length);
//     if($('.halskette_frontname_texts .halskette_name_texts').children().length > 0){
//       $('.halskette_frontname_texts .halskette_name_btn').hide();
//     }else{
//       $(this).val('');
//       console.log($('.halskette_frontname_texts .halskette_name_cancel_databtn').children().length);
//       if($('.halskette_frontname_texts .halskette_name_cancel_databtn').children().length > 0){
//         $('.halskette_frontname_texts .halskette_name_texts').hide();
//       $('.halskette_frontname_texts .halskette_name_btn').hide();
//       }else{
//         $('.halskette_frontname_texts .halskette_name_texts').hide();
//       $('.halskette_frontname_texts .halskette_name_btn').show();
//       }
//     }
//           if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//  $(".Namen-model-main").removeClass('model-open');
//     $("body").removeClass('popup_active');
//   });
// });


// // name back side cancel btn
// $(document).on('click', '.Ruckseitengravur-model-main .image_cancel_btn', function(){
//   var backsideval = $(this).parents('.Ruckseitengravur-model-main').find('.popup_name_inputs').val();
//     if($('.halskette_backname_texts .halskette_rucks_texts').children().length > 0){
//       $('.halskette_backname_texts .halskette_name_btn').hide();
// console.log('if');
//     }else{
// console.log('else');
//       $(this).parents('.Ruckseitengravur-model-main').find('.popup_name_inputs').val('');

//       if($('.halskette_backname_texts .halskette_rucks_cancel_databtn').children().length > 0){
// console.log('if1');
//         $('.halskette_backname_texts .halskette_rucks_texts').hide();
//       $('.halskette_backname_texts .halskette_name_btn').hide();
//       }else{
// console.log('else1');
//         $('.halskette_backname_texts .halskette_rucks_texts').hide();
//       $('.halskette_backname_texts .halskette_name_btn').show();
//       }
//     }
//       if (window.location.hash) {
//     history.replaceState(null, document.title, window.location.pathname + window.location.search);
//   }
//  $(".Ruckseitengravur-model-main").removeClass('model-open');
//     $("body").removeClass('popup_active');
//  // });
// });


// // back side cancel/skip btn
// $(document).on('click', '.backnamecancel_btn .halskette_name_btn', function(){
//   $('.halskette_backname_texts .halskette_header').hide();
//   $('.halskette_backname_texts .halskette_input_first').hide();
//   $(this).hide();
// $('.hintergrundfarbe').val('Transparent');
//   if($('.Ruckseitengravur-model-main').find('.wrap_image_wrapper').hasClass('portrait-auf-leinwand')){
//       $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="test-flex"><span class="flagship-collapsable-header">Hintergrundfarbe</span><span class="span-transparent">Weiß</span></span><button class="fflagship-collapsable-header-button2" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>');

//     $('.hintergrundfarbe').val('Weiß');
//   }else{
//       $('.halskette_backname_texts .halskette_rucks_cancel_databtn').html('<div class="halskette_name_cancel_data"><span class="test-flex"><span class="flagship-collapsable-header">Hintergrundfarbe</span><span class="span-transparent">Transparent</span></span><button class="fflagship-collapsable-header-button2" type="button" data-trigger-id="engraving-change">bearbeiten</button></div>');

//     $('.hintergrundfarbe').val('Transparent');
//   }
// });

// // name front side edit btn
// $(document).on('click', '.halskette_frontname_texts .engraving-editbutton', function(){
//   var datatriggerId = $(this).attr('data-trigger-id');
//  window.location.hash = '#popup';
// $(".Namen-model-main").addClass('model-open');
// $("body").addClass('popup_active');
//   $(".Namen-model-main .popup_fonts").find(datatriggerId).addClass('name_active');
// $(".Namen-model-main .popup_fonts").find(datatriggerId).trigger('click');
// });

// // name back side edit btn
// $(document).on('click', '.halskette_backname_texts .engraving-editbutton', function(){
//   var datatriggerId = $(this).attr('data-trigger-id');
//    window.location.hash = '#popup';
// $(".Ruckseitengravur-model-main").addClass('model-open');
// $("body").addClass('popup_active');
//   $(".Ruckseitengravur-model-main .popup_fonts").find(datatriggerId).addClass('name_active');
// $(".Ruckseitengravur-model-main .popup_fonts").find(datatriggerId).trigger('click');
// });

// // name front side remove btn
// $(document).on('click', '.halskette_frontname_texts .engraving-remove', function(){
// $('.halskette_name_texts').hide();
// $('.halskette_frontname_texts .halskette_name_btn').show();
//   $('.halskette_frontname_texts .halskette_input.frontnamecancel_btn').show();
//   $('.halskette_frontname_texts .halskette_header').show();
    
//   $(this).parents('.halskette_frontname_texts ').find('.halskette_name_texts').html('');
//   $('.Namen-model-main').find('#popup_name_image').html('');
//   $('.Namen-model-main').find('.popup_name_inputs').val('');

// });

// // name back side remove btn
// $(document).on('click', '.halskette_backname_texts .engraving-remove', function(){
// $('.halskette_rucks_texts').hide();
// $('.halskette_backname_texts .halskette_name_btn').show();
//   $('.halskette_backname_texts .halskette_header').show();
//    $('.halskette_backname_texts .halskette_input.backnamecancel_btn').show();
//   $(this).parents('.halskette_backname_texts ').find('.halskette_rucks_texts').html('');
//   if($('.Ruckseitengravur-model-main').find('.wrap_image_wrapper').hasClass('portrait-auf-leinwand')){
//     $('.Ruckseitengravur-model-main').find('.hintergrundfarbe').val('Weiß');
//   }else{
//     $('.Ruckseitengravur-model-main').find('.hintergrundfarbe').val('Transparent');
//   }
  
//   // $('.Ruckseitengravur-model-main').find('#popup_name_images').html('');
//   // $('.Ruckseitengravur-model-main').find('.popup_name_inputs').val('');  
//  getPrice();
// });

// $(document).on('click', '.halskette_frontname_texts .engraving-addedbutton', function(){
//   var datatriggerId = $(this).attr('data-trigger-id');
//  window.location.hash = '#popup';
// $(".Namen-model-main").addClass('model-open');
// $("body").addClass('popup_active');
//   $(".Namen-model-main .popup_fonts").find(datatriggerId).addClass('name_active');
// $(".Namen-model-main .popup_fonts").find(datatriggerId).trigger('click');
// });

// $(document).on('click', '.halskette_backname_texts .engraving-addedbutton', function(){
//   var datatriggerId = $(this).attr('data-trigger-id');
//  window.location.hash = '#popup';
// $(".Ruckseitengravur-model-main").addClass('model-open');
// $("body").addClass('popup_active');
//   $(".Ruckseitengravur-model-main .popup_fonts").find(datatriggerId).addClass('name_active');
// $(".Ruckseitengravur-model-main .popup_fonts").find(datatriggerId).trigger('click');
// });


// $(document).on('click', '.halskette_frontname_texts .flagship-collapsable-header-button', function(){
//  window.location.hash = '#popup';
// $(".Namen-model-main").addClass('model-open');
// $("body").addClass('popup_active');
//   $(".Namen-model-main .popup_fonts").find('.frontname_1').addClass('name_active');
// $(".Namen-model-main .popup_fonts").find('.frontname_1').trigger('click');
// });



// $(document).on('click', '.halskette_backname_texts .flagship-collapsable-header-button', function(){
//  window.location.hash = '#popup';
// $(".Ruckseitengravur-model-main").addClass('model-open');
// $("body").addClass('popup_active');
//   $(".Ruckseitengravur-model-main .popup_fonts").find('.frontname_1').addClass('name_active');
// $(".Ruckseitengravur-model-main .popup_fonts").find('.frontname_1').trigger('click');
// });

// $(document).on('change', '.halskette_radio input', function(){
// changeAddHalsketteProduct();
//   getPrice();
// });



// function getRandomInt(min, max) {
//   return Math.floor(Math.random() * (max - min)) + min;
// }

// function changeAddHalsketteProduct(){
// var list_item_value = $('.selected-option span.list_item_value').text();
// var checkedValue = $('.halskette_radio input:checked').attr('id');
// var mainProductvarId = $('.addHalsketteProduct').parents('.product-single__form').find('.product-single__variants').val();
//   console.log(mainProductvarId);
// if( !(list_item_value == '1 Tier/Person' || list_item_value == '' ) || checkedValue == 'Ja'){
// var title = list_item_value + ' / ' + checkedValue;
// var id = $('.addHalsketteProduct option[data-title="'+title+'"]').attr('value');
// $('.addHalsketteProduct').val(id);
// }
// }
 
// function addHalsketteProduct(){
// var personen = $('.halskette_personen').val();
// var mainProductvarId = getRandomInt(10000, 99999);
// var items = [];
// var bundleItem = [];
// if(!(personen == '1' || personen === undefined )){
// var id = $('.addHalsketteProduct option[data-title="'+personen+'"]').attr('value');
// items.push({ 'id':id,'quantity':1, 'properties': {'_bundleWithItem': mainProductvarId} });
// bundleItem.push(id);
// }
// var checkedValue = $('.halskette_radio input:checked').attr('id');
// if(checkedValue == 'Ja'){
// var id = $('.handzeichnung').val();
// items.push({ 'id':id,'quantity':1, 'properties': {'_bundleWithItem': mainProductvarId} });
// bundleItem.push(id);
// }
// var zeichnungsstil = $('#Farbig:checked').val();
// if(!(zeichnungsstil === undefined || zeichnungsstil == '' )){
// var id = $('.zeichnungsstil').val();
// items.push({ 'id':id,'quantity':1, 'properties': {'_bundleWithItem': mainProductvarId} });
// bundleItem.push(id);
// }
// console.log(items);
// $('.bundleItem').val(mainProductvarId);
//   var data = {
//     items: items
//   };
//  $.ajax({
//    type: 'POST', 
//    url: '/cart/add.js',
//    dataType: 'json', 
//    data : data,
//    success: function() {
//     console.log('added');
//    }
// });
// }



// function getPrice(){
// var id = $('[data-product-select]').val();
// var price = $(`[data-product-select] option[value="${id}"]`).attr('data-price') * 1;
// console.log(price);
// var personen = $('.halskette_personen').val();
// if(!(personen == '1' || personen == '' || personen == undefined )){
// var halskette_personen_price = $('.addHalsketteProduct option[data-title="'+personen+'"]').attr('data-price') * 1;
//   price = price + halskette_personen_price * 1;
//   console.log(price);
// }
// var checkedValue = $('.halskette_radio input:checked').attr('id');
// if(checkedValue == 'Ja'){
// var handzeichnung_price = $('.handzeichnung').attr('data-price') * 1;
// price = price + handzeichnung_price; 
//   console.log(price);
// }
// var zeichnungsstil = $('#Farbig:checked').val();
// if(!(zeichnungsstil === undefined || zeichnungsstil == '' )){
// var zeichnungsstil_price = $('.zeichnungsstil').attr('data-price') * 1;
// price = price + zeichnungsstil_price; 
//   console.log(price);
// }
// var formattedAmount =  theme.Currency.formatMoney(price,theme.settings.moneyFormat);
//   $('[data-product-price]').text(formattedAmount);
// }


function uploadkit(){
  if($('.uploadkit-thumbnail').children().length == 0){
     $('.custom_uploadkit .uploadkit-uploader .image_save').remove(); 
   }
 $('.uploadkit-thumbnail').each(function(index) {
    var image = $(this);
    var field = image.next('.uploadkit-field');
    var wrapper = image.closest('.uploadkit-main-wrapper');
   //console.log($(this).find('.uploadkit-main-wrapper').length);
    if (wrapper.length === 0) {
      wrapper = $('<div class="uploadkit-main-wrapper"></div>');
      image.add(field).wrapAll(wrapper);
            $(this).wrap($('<div class="uploadkit-wrapper-img"></div>'));
      $(this).wrap($('<div class="wrapper-img"></div>'));

    }
   //console.log($('.uploadkit-thumbnail').children().length);
   
  // console.log($('.uploadkit-main-wrapper').length);
   if($('.uploadkit-main-wrapper').length == 2 || $('.uploadkit-main-wrapper').length == 1){
     $('.uploadkit-main-wrapper').css('width', '45%');
   }
   if($('.uploadkit-main-wrapper').length == 3 || $('.uploadkit-main-wrapper').length == 4 || $('.uploadkit-main-wrapper').length == 5){
   $('.uploadkit-main-wrapper').css('width', '31%');
   }
   if($('.custom_uploadkit .uploadkit-uploader .image_save').length == 0){
     if($('.uploadkit-main-wrapper').length >= 1){
       $('.custom_uploadkit').find('.uploadkit-button.uploadkit-button-uploaded').before('<button type="button" class="image_save">Sichern</button>');
       $('.custom_uploadkit .uploadkit-uploader').find('.uploadkit-button.uploadkit-button-uploaded').addClass('uploaded_button_full');
   }
   }
  });
} 
setInterval(uploadkit, 800);


$(document).on('click', '.uploadkit-wrapper-img', function(event){
 if ($(event.target).is('div.wrapper-img')) {
  $(this).find('img.uploadkit-thumbnail').trigger('click');
 }
});
$(document).on('click', '.image_save', function(event){
  $('.halsketteupload_header').hide();
  $('.halsketteupload_content').hide();
  $('.after_upload_photo').show();
    $('html, body').animate({
        scrollTop: $("#foto").offset().top -160
    }, 400);  
});

$(document).on('click', '.halsketteupload_edit_text', function(event){
  $('.after_upload_photo').hide();
  $('.halsketteupload_header').show();
  $('.halsketteupload_content').show();
});





// // Scroll on touch code
// // Scroll on touch code for all elements matching the selector
// function touchScroll($bind = '') {
//   const sliders = document.querySelectorAll($bind);

//   if (!sliders.length) {
//     // console.error(`No elements found with selector '${$bind}'.`);
//     return;
//   }

//   sliders.forEach(slider => {
//     let isDown = false;
//     let startX;
//     let scrollLeft;
//     let velX = 0;
//     let momentumID;

//     slider.addEventListener('mousedown', (e) => {
//       isDown = true;
//       slider.classList.add('active');
//       startX = e.pageX - slider.offsetLeft;
//       scrollLeft = slider.scrollLeft;
//       cancelMomentumTracking();
//     });

//     slider.addEventListener('mouseleave', () => {
//       isDown = false;
//       slider.classList.remove('active');
//     });

//     slider.addEventListener('mouseup', () => {
//       isDown = false;
//       slider.classList.remove('active');
//       beginMomentumTracking();
//     });

//     slider.addEventListener('mousemove', (e) => {
//       if (!isDown) return;
//       e.preventDefault();
//       const x = e.pageX - slider.offsetLeft;
//       const walk = (x - startX) * 1; // Scroll fast
//       var prevScrollLeft = slider.scrollLeft;
//       slider.scrollLeft = scrollLeft - walk;
//       velX = slider.scrollLeft - prevScrollLeft;
//     });

//     slider.addEventListener('wheel', (e) => {
//       cancelMomentumTracking();
//     });

//     function beginMomentumTracking() {
//       cancelMomentumTracking();
//       momentumID = requestAnimationFrame(momentumLoop);
//     }

//     function cancelMomentumTracking() {
//       cancelAnimationFrame(momentumID);
//     }

//     function momentumLoop() {
//       slider.scrollLeft += velX;
//       velX *= 0.95;
//       if (Math.abs(velX) > 0.5) {
//         momentumID = requestAnimationFrame(momentumLoop);
//       }
//     }
//   });
// }

// // Usage example
// touchScroll('.popup_fonts');





    // // Your JSON data containing mobile brands and models
    // var mobileData = {"Apple":["iPhone 15 Pro Max","iPhone 15 Plus","iPhone 15 Pro","iPhone 15","iPhone 14 Pro Max","iPhone 14 Plus","iPhone 14 Pro","iPhone 14","iPhone 13 Pro Max","iPhone 13 Pro","iPhone 13","iPhone 13 mini","iPhone 12 Pro Max","iPhone 12 Pro","iPhone 12","iPhone 12 mini","iPhone 11 Pro Max","iPhone 11 Pro","iPhone 11","iPhone X/XS","iPhone XS Max","iPhone XR","iPhone 7 Plus/8 Plus","iPhone 7/8/SE2020/SE2022","iPhone 6 Plus/6s Plus","iPhone 6/6s","iPhone 5/5s/SE2016"],
    //                     "Samsung":["Galaxy S23 Ultra","Galaxy S23+","Galaxy S23","Galaxy S22 Ultra","Galaxy S22 Plus","Galaxy S22","Galaxy S21 Ultra 5G","Galaxy S21 Plus 5G","Galaxy S21 FE","Galaxy S21 5G","Galaxy S20 FE/S20 FE 5G/S20 FE 2022","Galaxy S20/S20 5G","Galaxy S20 Ultra/S20 Ultra 5G","Samsung Galaxy S20 Plus/S20 Plus 5G","Galaxy S10 Lite","Galaxy S10e","Galaxy S10 Plus","Galaxy S10","Galaxy S9 Plus","Galaxy S9","Galaxy S8 Plus","Galaxy S8","Galaxy Note 20 Ultra/20 Ultra 5G","Galaxy Note 20/20 5G","Galaxy Note 10 Plus/10 Plus 5G","Galaxy Note 10 Lite","Galaxy Note 10/10 5G","Galaxy Note 9","Galaxy Note 8","Galaxy A80","Galaxy A73 5G","Galaxy A71 4G","Galaxy A70","Galaxy A72/A72 5G","Galaxy A54 5G","Galaxy A53 5G","Galaxy A52/A52 5G/A52s 5G","Galaxy A51 5G","Galaxy A42 5G","Galaxy A41","Galaxy A40","Galaxy A33 5G","Galaxy A32 5G","Galaxy A32 4G","Galaxy A31","Galaxy A30s/A50/A50s","Galaxy A23 5G","Galaxy A22 5G","Galaxy A22 4G","Galaxy A21s","Galaxy A20s","Galaxy A20e","Galaxy A13 5G","Galaxy A13 4G","Galaxy A12/A12 Nacho","Galaxy A10e","Galaxy A03s","Galaxy A03"],
    //                     "Huawei":["P50 Pro","P50/P50E","P40 Pro Plus","P40 Pro","P40 Lite","P40","P30 Lite","P30 Pro","P30","P20 Lite (2019)","P20 Lite","P20"],
    //                     "Xiaomi":["12 Lite","12 Pro/12S Pro/12 Pro","12/ 12S/12X","Redmi Note 11 Pro/Redmi Note 11 Pro 5G","Xiaomi 11i/11i HyperCharge","Redmi Note 11/Redmi Note 11S","11T/11T Pro","Redmi Note 10 5G/Poco M3 Pro 5G","Redmi Note 10/Redmi Note 10S","Redmi Note 10 Pro","Redmi Note 9","Redmi 10/Redmi 10 2022","Redmi Note 9 Pro/Xiaomi Redmi Note 10 Lite","Redmi 9T","Redmi 9","Poco M4 Pro 5G","Poco X4 Pro 5G","Poco X4 GT","Poco X3 NFC/Poco X3 Pro","Poco F4","Mi Note 10/Mi Note 10 Pro","Mi Mix 4","Mi Mix 3","Mi 11 Ultra","Mi 11 Lite/11 Lite 5G NE","Mi 11","Mi 10T Lite 5G","Mi 10T 5G/Mi 10T Pro 5G","Mi 10 Pro"]
    //                    };
//     var mobileData;
// var brandModelElement = document.getElementById('brand_model');
// if (brandModelElement) {
//     mobileData = JSON.parse(brandModelElement.textContent);
//     // Now you can work with mobileData
// } 

//     // Function to populate the mobile brands select box
//     function populateBrands() {
//       const brandsSelect = $("#custom-select-hersteller");
//       for (const brand in mobileData) {
//         brandsSelect.append(`<li value="${brand}"><div class="list_item"><span data-value="${brand}" class="list_item_value">${brand}</span></div></li>`);
//       }
//     }

//     // Function to populate the mobile models select box
//     function populateModels(brand) {

//       const modelsSelect = $("#custom-select-handymodell");
//       modelsSelect.empty();
// console.log(modelsSelect);
// if(mobileData){
//       if (mobileData.hasOwnProperty(brand)) {
//         mobileData[brand].forEach(function(model) {

//         modelsSelect.append(`<li value="${model}"><div class="list_item"><span data-value="${model}" class="list_item_value">${model}</span></div></li>`);
//         });
//       }
//     }
//     }
// if(mobileData){
// if (mobileData.hasOwnProperty('options')) {
// $('.select-handymodell').addClass('active');
// populateModels('options');
// }else{
// populateBrands();
// }
// }




// $(document).on('click', "#custom-select-hersteller li", function(){
//   var selectedOption = $(this).html();
//   var selectedValue = $(this).attr("value");

// $('.select-handymodell').addClass('active');


//   $('.Namen-model-main .frontname').removeClass('name_active');
//   var selectedDataVal = $(this).parents('.halskette_selecteditems').find('.select-trigger .selected-option .list_item .list_item_value').attr('data-value');
//   $('.halskette_frontname_texts .halskette_name_texts').html('');
//   $('.halskette_frontname_texts .frontnamecancel_btn').show();
//   $('.halskette_frontname_texts .halskette_name_btn').show();
//   $('.Namen-model-main #popup_name_image').html('');
//   $('.Namen-model-main .popup_name_inputs').val('');
//   $('.Namen-model-main #frontname_1').addClass('name_active');
//   $('.halskette_frontname_texts .halskette_header').show();
//   $('.halskette_frontname_texts .halskette_input_first').show();
//   $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('');
//   $(this).parents('.custom-select').find(".selected-option").html(selectedOption);
//   $(".options").slideUp("fast");
//   $('.input-hersteller').val(selectedValue);
//   $(".options").removeClass("selected_open");
//   $(this).parents('.custom-select').find('.select-trigger').removeClass('selector_open');
//   // Perform any additional actions with the selected value here
//   checkError();
//   populateModels(selectedValue);
//   });


// $(document).on('click', "#custom-select-handymodell li", function(){
//   var selectedOption = $(this).html();
//   var selectedValue = $(this).attr("value");
//   $('.Namen-model-main .frontname').removeClass('name_active');
//   var selectedDataVal = $(this).parents('.halskette_selecteditems').find('.select-trigger .selected-option .list_item .list_item_value').attr('data-value');
//   $('.halskette_frontname_texts .halskette_name_texts').html('');
//   $('.halskette_frontname_texts .frontnamecancel_btn').show();
//   $('.halskette_frontname_texts .halskette_name_btn').show();
//   $('.Namen-model-main #popup_name_image').html('');
//   $('.Namen-model-main .popup_name_inputs').val('');
//   $('.Namen-model-main #frontname_1').addClass('name_active');
//   $('.halskette_frontname_texts .halskette_header').show();
//   $('.halskette_frontname_texts .halskette_input_first').show();
//   $('.halskette_frontname_texts .halskette_name_cancel_databtn').html('');
//   $(this).parents('.custom-select').find(".selected-option").html(selectedOption);
//   $(".options").slideUp("fast");
//   $('.input-handymodell').val(selectedValue);
//   $(".options").removeClass("selected_open");
//   $(this).parents('.custom-select').find('.select-trigger').removeClass('selector_open');
//    checkError();
//   });



// function checkError(){
// var handymodell = $('.input-handymodell').val();
// var hersteller = $('.input-hersteller').val();
// var personen = $('.halskette_personen').val();
//   console.log(personen);

 
//   if( handymodell == '' || hersteller =='' || personen == ''){
//     $('.add-to-cart').addClass('disabled');
//     if(personen != ''){
//     $('.select-personen').removeClass('error-text');
//     }
//     if(hersteller != ''){
//     $('.select-hersteller').removeClass('error-text');
//     }
//     if(handymodell != ''){
//     $('.select-handymodell').removeClass('error-text');
//     }
       
// }else{
// $('.select-trigger').removeClass('error-text');
// $('.add-to-cart').removeClass('disabled');
// $('.select-hersteller').removeClass('error-text');
//     $('.select-handymodell').removeClass('error-text');
// $('.line-item-property__field.radio-buttons').removeClass('error-text');
// $('.error').hide();
// }
//   if($('.radio-buttons input').length > 0){
//     var radiobutton = $('.radio-buttons input:checked').val();
//      if(radiobutton == undefined || personen == ''){
//     $('.add-to-cart').addClass('disabled');
//      if(radiobutton != undefined){
//     $('.line-item-property__field.radio-buttons').removeClass('error-text');
//     }
//        if(personen != ''){
//     $('.select-personen').removeClass('error-text');
//     }
//   }else{
//        $('.select-trigger').removeClass('error-text');
//     $('.add-to-cart').removeClass('disabled');
//     $('.line-item-property__field.radio-buttons').removeClass('error-text');
//     $('.error').hide();
// }
//   }
 
  
// }

// end if 

// $(document).on('click', '.halskette-product-add-btn.add-to-cart.disabled', function(event){
// event.preventDefault();
// var handymodell = $('.input-handymodell').val();
// var hersteller = $('.input-hersteller').val();
// var personen = $('.halskette_personen').val();
//   // var radiobutton = $('.radio-buttons input[name="properties[Zeichnungsstil]"]:checked').val();
// if( handymodell == '' || hersteller =='' || personen == '' ){
// $('.error').show();
// if(personen == ''){
// $('.select-personen').addClass('error-text');
// }
// if(hersteller == ''){
// $('.select-hersteller').addClass('error-text');
// }
// if(handymodell == ''){
// $('.select-handymodell').addClass('error-text');
// }
// // if(radiobutton == undefined){
// // $('.line-item-property__field.radio-buttons').addClass('error-text');
// // }
// }
// });

// $(document).on('change', '[data-variant-input]', function(){
//   getPrice();
// });

// var interval = setInterval(checkURL, 1000);
// function checkURL() {
//     var currentURL = window.location.href;
//     if (currentURL.indexOf('#') === -1) {
//     // var hashValue = currentURL.split('#')[1];
//     // if (hashValue === undefined || hashValue === '') {
//     //     $('.aufFoto-model-main.model_container').removeClass('model-open');
//     // $('body.template-product').removeClass('popup_active');
//     // }
//     // }else{
//     $('.aufFoto-model-main').removeClass('model-open');
//     $(".Weitere-model-main").removeClass('model-open');
//     $(".Zeichnungsstil-model-main").removeClass('model-open');
//     $(".Handzeichnung-model-main").removeClass('model-open');
//     $(".Namen-model-main").removeClass('model-open');
//     $(".Ruckseitengravur-model-main").removeClass('model-open');
//     $('body.template-product').removeClass('popup_active');
// }
// }